module.exports = __webpack_public_path__ + "static/media/fx-page2.73019875.png";